import { UserList } from '@src/manageUsers/domain/UserList';
import { UsersClient } from '@src/manageUsers/services/UsersClient';
import { useQuery } from '@tanstack/react-query';

export const useUsers = () => {
  const { data: userList = new UserList([]), isLoading } = useQuery<UserList>({
    queryKey: ['users.list'],
    queryFn: UsersClient.list,
  });

  return {
    isLoading,
    userList: userList.sort(),
  };
};
